import { Switch } from 'react-router'

import { PrivateRoute } from '../../App'
import { Header } from '../../components'
import { MasaDashboardPaths } from '../../config/routes'
import { BackofficeDashboard } from './masa-dashboard-pages/backoffice-dashboard'
import { User } from './masa-dashboard-pages/user'
import { UserAccounts } from './masa-dashboard-pages/user-accounts'
import { Users } from './masa-dashboard-pages/users'

export function MasaDashboard() {
    return (
        <div
            className='grid w-screen'
            style={{
                height: '100vh',
                gridTemplateRows: '80px 1fr',
            }}>
            <Header />
            <Switch>
                <PrivateRoute path={MasaDashboardPaths.USERS}>
                    <Users />
                </PrivateRoute>
                <PrivateRoute path={MasaDashboardPaths.USER_ACCOUNTS}>
                    <UserAccounts />
                </PrivateRoute>
                <PrivateRoute path={MasaDashboardPaths.USER}>
                    <User />
                </PrivateRoute>
                <PrivateRoute path={MasaDashboardPaths.ROOT}>
                    <BackofficeDashboard />
                </PrivateRoute>
            </Switch>
        </div>
    )
}
